import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GlobalService } from './global.service';

import { AppResponse } from 'app/schedule/_models/app-response.model';
import { ISchedulingSlotsResponse } from 'app/schedule/_models/scheduling-slots-result.model';
import { IScheduling } from 'app/schedule/_models/scheduling.model';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderSchedulingService {
  constructor(
    private readonly globalService: GlobalService,
    protected _http: HttpClient
  ) {}

  /**
   * Get Panel Info
   * @param orderId - order id
   * @param args
   * @returns Scheduling
   */
  getPainelInfo(args): Observable<IScheduling> {
    const endpoint = '/listeners/ms/workorder/workorder/scheduling/get-painel-info';

    return this._http.post(endpoint, args).pipe(
      map((response: any) => {
        return response.Body.Result;
      })
    );
  }

  /**
   * Get Scheduling
   * @param orderId - Order ID
   * @param source - The origin source of work order
   * @param startFrom - The start date (optional)
   * @param payload
   * @returns SchedulingResult
   */
  getScheduling(payload: any): Observable<ISchedulingSlotsResponse> {
    const endpoint = '/listeners/ms/workorder/workorder/scheduling/get-scheduling-without-painel-info';
    const args = {
      operationType: payload.operationType,
      deliveryPointCode: payload.deliveryPointCode,
      taxNumber: payload.taxNumber,
      supplier: payload.supplier,
      startFrom: payload.startFrom,
      producer: payload.producer,
      internalOrderId: payload.internalOrderId,
      orderSubType: payload.orderSubType,
      latitude: payload.latitude,
      longitude: payload.longitude,
      addressPostalCode: payload.addressPostalCode,
      addressStreet: payload.addressStreet,
      adminDivision1: payload.adminDivision1,
      adminDivision2: payload.adminDivision2,
      organizationalUnit3: payload.organizationalUnit3,
      endDate: payload.endDate,
      startDate: payload.startDate,
      schedulingID: payload.schedulingId,
    };

    return this._http.post(endpoint, args).pipe(
      map((response: AppResponse<ISchedulingSlotsResponse>) => {
        return response.Body.Result;
      })
    );
  }
}
